module.exports = __webpack_public_path__ + "img/loading.b0d041a0.svg";